import { useQuery } from 'react-query';
import { bffInstance } from "../api/axiosInstance";

const getMeetMyCdkContact = async (enterpriseId: string,storeId: string,isAccess: boolean) => {
  const res = await bffInstance.get<Record<any, any>[]>(`/getSFCDKContactDetails/${enterpriseId}/${storeId}/${isAccess}`);
  return res.data;
};

export function useGetMeetMyCdkContant(enterpriseId: string,storeId: string,isAccess: boolean) {
  return useQuery(['getMeetMyCdkContact', enterpriseId, storeId,isAccess], () => getMeetMyCdkContact(enterpriseId,storeId,isAccess),
  { enabled:  !!storeId && !!enterpriseId && !!isAccess});
}

const getCMFNumber = async (enterpriseId: string,storeId: string) => {
  const res = await bffInstance.get<Record<any, any>[]>(`/getSFCMFDetails/${enterpriseId}/${storeId}`);
  return res.data;
};
    
export function useGetCMFNumber(enterpriseId: string,storeId: string) {
  return useQuery(['getCMFNumber', enterpriseId, storeId], () => getCMFNumber(enterpriseId,storeId),
  { enabled:  !!storeId && !!enterpriseId});
}

